/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface SoldeApprenantSearch
 */
export interface SoldeApprenantSearch {
    /**
     * 
     * @type {number}
     * @memberof SoldeApprenantSearch
     */
    idapprenant?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof SoldeApprenantSearch
     */
    anneeScolaire?: TextSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof SoldeApprenantSearch
     */
    idcentre?: Int32ListSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof SoldeApprenantSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SoldeApprenantSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SoldeApprenantSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SoldeApprenantSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SoldeApprenantSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SoldeApprenantSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SoldeApprenantSearch interface.
 */
export function instanceOfSoldeApprenantSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SoldeApprenantSearchFromJSON(json: any): SoldeApprenantSearch {
    return SoldeApprenantSearchFromJSONTyped(json, false);
}

export function SoldeApprenantSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): SoldeApprenantSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : TextSearchFromJSON(json['anneeScolaire']),
        'idcentre': !exists(json, 'idcentre') ? undefined : Int32ListSearchFromJSON(json['idcentre']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SoldeApprenantSearchToJSON(value?: SoldeApprenantSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'anneeScolaire': TextSearchToJSON(value.anneeScolaire),
        'idcentre': Int32ListSearchToJSON(value.idcentre),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

